module.exports = __webpack_public_path__ + "img/black_pumpkins.f51fbe43.jpg";